<app-breadcrumb *ngIf="showHeader" [styleBreadcrumb]="'page-heading'" [title]="'MEMBERS-SEARCH'"
  [breadcrumb]="breadcrumb" [isStringLiteral]="false" icon="fa-users">
</app-breadcrumb>

<!--Render separate or in a tab -->
<ng-template *ngIf="!displayTab" [ngTemplateOutlet]="searchTemplate"></ng-template>
<kendo-tabstrip #tabstrip *ngIf="displayTab">
  <kendo-tabstrip-tab title="{{ 'SEARCH-MEMBER-TAB' | translate:patientLabel }}" [selected]="true"
    style="padding:20px;">
    <ng-template kendoTabContent>
      <ng-template [ngTemplateOutlet]="searchTemplate"></ng-template>
    </ng-template>
  </kendo-tabstrip-tab>
</kendo-tabstrip>

<!--Create member confirmation-->
<kendo-dialog title="{{ 'PLEASE-CONFIRM' | translate }}" *ngIf="confirmAddMember" (close)="confirmAddMember = false;"
  [minWidth]="250" [width]="450">
  <p>{{ 'CONFIRM-MEMBER-IMPORT' | translate:patientLabel }}</p>
  <span class="k-font-weight-bold">{{selectedMember.fullName}}</span>
  <kendo-dialog-actions>
    <button kendoButton (click)="continueImportAction(false)">{{ 'NO' | translate }}</button>
    <button appPreventClick kendoButton (click)="continueImportAction(true)" [primary]="true">{{ 'YES' | translate
      }}</button>
  </kendo-dialog-actions>
</kendo-dialog>

<app-member-send-selection [memberSelected]="memberSelected" [open]="openSendMethodDialog" [type]="sendMethodType"
  (closing)="closeSendMethod($event)">
</app-member-send-selection>

<ng-template #searchTemplate>
  <form novalidate [formGroup]="searchForm" class="k-form" (keydown)="keyDown($event)">
    <div *ngIf="loading && nextAvailableEnabled" class="row justify-content-center">
      <span class="k-icon k-i-loading kendo-loading-icon mt-4"></span>
    </div>
    <div *ngIf="!nextAvailableEnabled">
      <div class="row reduced-search-criteria-margin">
        <div class="col-2">
          <label class="k-form-field">
            <span class="k-text-uppercase dark">
              {{'FIRST-NAME' | translate}}
            </span>
            <input id="firstName" kendoTextBox formControlName="firstName" />
          </label>
        </div>
        <div class="col-2">
          <label class="k-form-field">
            <span class="k-text-uppercase dark">
              {{'LAST-NAME' | translate}}
            </span>
            <input id="lastName" kendoTextBox formControlName="lastName" />
          </label>
        </div>
        <div class="col-2">
          <label class="k-form-field">
            <span class="k-text-uppercase dark">
              {{'MIDDLE-NAME' | translate}}
            </span>
            <input id="middleName" kendoTextBox formControlName="middleName" />
          </label>
        </div>
        <div class="col-2">
          <label class="k-form-field">
            <span class="k-text-uppercase dark">
              {{'GENDER' | translate}}
            </span>
            <kendo-combobox class="w-100" id="gender" formControlName="gender" [data]="genders"
              [textField]="'displayName'" [valueField]="'id'">
            </kendo-combobox>
          </label>
        </div>
        <div class="col-2">
          <label class="k-form-field">
            <span class="k-text-uppercase dark">
              {{'DATE-OF-BIRTH' | translate}}
            </span>
            <kendo-datepicker [min]="minDOB" [max]="maxDOB" formControlName="dateOfBirth" class="w-100">
            </kendo-datepicker>
            <div class="k-tooltip k-tooltip-validation" role="alert" *ngIf="dateOfBirth.invalid && dateOfBirth.touched">
              <span>{{ 'DATE-INVALID' | translate }}</span>
            </div>
          </label>
        </div>
        <div class="col-2">
          <label class="k-form-field">
            <span class="k-text-uppercase dark">
              <i class="fas fa-phone fa-fw"></i> {{'HOME-PHONE' | translate}}
            </span>
            <kendo-maskedtextbox [mask]="phoneNumberMask" id="homePhoneNumber" formControlName="homePhoneNumber">
            </kendo-maskedtextbox>
            <div class="k-tooltip k-tooltip-validation" role="alert"
              *ngIf="homePhoneNumber.invalid && homePhoneNumber.touched">
              <span>{{ 'IMPORT-PHONE-INVALID' | translate }}</span>
            </div>
          </label>
        </div>
        <div class="col-2">
          <label class="k-form-field">
            <span class="k-text-uppercase dark">
              <i class="fas fa-mobile-android-alt fa-fw"></i> {{'CELL-PHONE' | translate}}
            </span>
            <kendo-maskedtextbox [mask]="phoneNumberMask" id="cellPhoneNumber" formControlName="cellPhoneNumber">
            </kendo-maskedtextbox>
            <div class="k-tooltip k-tooltip-validation" role="alert"
              *ngIf="cellPhoneNumber.invalid && cellPhoneNumber.touched">
              <span>{{ 'IMPORT-PHONE-INVALID' | translate }}</span>
            </div>
          </label>
        </div>
        <div class="col-2">
          <label class="k-form-field">
            <span class="k-text-uppercase dark">
              <i class="fas fa-phone-office fa-fw"></i> {{'WORK-PHONE' | translate}}
            </span>
            <kendo-maskedtextbox [mask]="phoneNumberMask" id="workPhoneNumber" formControlName="workPhoneNumber">
            </kendo-maskedtextbox>
            <div class="k-tooltip k-tooltip-validation" role="alert"
              *ngIf="workPhoneNumber.invalid && workPhoneNumber.touched">
              <span>{{ 'IMPORT-PHONE-INVALID' | translate }}</span>
            </div>
          </label>
        </div>
        <div class="col-2">
          <label class="k-form-field">
            <span class="k-text-uppercase dark">
              {{'ADDRESS' | translate}}
            </span>
            <input id="npi" kendoTextBox formControlName="address" />
          </label>
        </div>
        <div class="col-2">
          <label class="k-form-field">
            <span class="k-text-uppercase dark">
              {{'CITY' | translate}}
            </span>
            <input id="city" kendoTextBox formControlName="city" />
          </label>
        </div>
        <div class="col-2">
          <label class="k-form-field">
            <span class="k-text-uppercase dark">
              {{'STATE' | translate}}
            </span>
            <kendo-combobox class="w-100" id="state" formControlName="state" [data]="states" [textField]="'displayName'"
              [valueField]="'id'">
            </kendo-combobox>
          </label>
        </div>
        <div class="col-2">
          <label class="k-form-field">
            <span class="k-text-uppercase dark">
              {{'POSTAL-CODE' | translate}}
            </span>
            <input id="postalCode" kendoTextBox formControlName="postalCode" />
          </label>
        </div>
        <div class="col-2">
          <label class="k-form-field">
            <span class="k-text-uppercase dark">
              <i class="fas fa-envelope fa-fw"></i> {{'EMAIL' | translate}}
            </span>
            <input id="email" kendoTextBox formControlName="email" email />
            <div class="k-tooltip k-tooltip-validation" role="alert"
              *ngIf="searchForm.controls['email'].invalid && searchForm.controls['email'].touched">
              {{'WRONG-EMAIL-FORMAT' | translate}}
            </div>
          </label>
        </div>
        <div class="col-2">
          <label class="k-form-field">
            <span class="k-text-uppercase dark">
              {{'IDENTIFIER-TYPE' | translate}}
            </span>
            <kendo-combobox class="w-100" id="identifierDictionary" formControlName="identifierDictionary"
              [data]="subjectIdentifiers" [textField]="'displayName'" [valueField]="'id'" [valuePrimitive]="true">
            </kendo-combobox>
          </label>
        </div>
        <div class="col-2">
          <label class="k-form-field"
            *ngIf="identifierDictionary.value !== null && identifierDictionary.value !== undefined && identifierDictionary.value !== ''">
            <span class="k-text-uppercase dark">
              {{'IDENTIFIER-VALUE' | translate}}
            </span>
            <input id="identifier" kendoTextBox formControlName="identifier" />
            <div class="k-tooltip k-tooltip-validation" role="alert" *ngIf="identifier.invalid && identifier.touched">
              <span>{{ 'REQUIRED-IDENTIFIER' | translate}}</span>
            </div>
          </label>
        </div>
        <div class="col-2" *ngIf="clientExtensionsFiltered.length > 0">
          <label class="k-form-field">
            <span class="k-text-uppercase dark">
              {{'EXTENSION-TYPE' | translate}}
            </span>
            <kendo-combobox class="w-100" id="extensionType" formControlName="extensionType"
              [data]="clientExtensionsFiltered" [textField]="'name'" [valueField]="'id'" [valuePrimitive]="true"
              [virtual]="virtualClientExtension">
            </kendo-combobox>
          </label>
        </div>
        <div class="col-2">
          <label class="k-form-field"
            *ngIf="extensionType.value !== null && extensionType.value !== undefined && extensionType.value !== ''">
            <span class="k-text-uppercase dark">
              {{'EXTENSION' | translate}}
            </span>
            <input id="extension" kendoTextBox formControlName="extension" />
            <div class="k-tooltip k-tooltip-validation" role="alert" *ngIf="extension.invalid && extension.touched">
              <span>{{ 'EXTENSION-REQUIRED' | translate}}</span>
            </div>
          </label>
        </div>
        <div class="col-2">
          <label class="k-form-field" *ngIf="showPatientSearchSources">
            <span class="k-text-uppercase dark">
              {{'SEARCH-SOURCES' | translate}} *
            </span>
            <kendo-multiselect id="searchSources" [data]="searchSourcesFiltered" formControlName="searchSources"
              [textField]="'displayName'" [filterable]="true" [valueField]="'id'"
              (filterChange)="filterSearchSources($event)" (close)="searchTerm=''" [autoClose]="true"
              [virtual]="virtualSource">
              <ng-template kendoMultiSelectItemTemplate let-dataItem>
                <span innerHTML="{{ dataItem.displayName | highlight : searchTerm }}" class="ellipsis-text"> </span>
              </ng-template>
            </kendo-multiselect>
          </label>
          <div class="pt-2" [ngClass]="{'extra-top': !showPatientSearchSources}">
            <button kendoButton type="button" [disabled]="searchDisabled() && !creatingCase"
              (click)="searchMembers(true)">
              {{'SEARCH' | translate}}<i class="far fa-search"></i>
            </button>
            <i class="fas fa-fw fa-times-circle fa-delete-custom ml-2" title="{{'SEARCH-CLEAR-ALL' | translate}}"
              [hidden]="clearHidden()" (click)="clearSearch()" role="button"
              attr.aria-label="{{'SEARCH-CLEAR-ALL' | translate}}" tabindex="0" (keydown.enter)="clearSearch()"
              (keydown.space)="clearSearch()" style="font-size:20pt;position:relative;top:7px;padding-top:0;">
            </i>
          </div>
        </div>
      </div>
    </div>
    <div class="row mt-3 mb-3">
      <!--Search Results-->
      <div class="col-sm-12" [ngStyle]="{'max-height': maxGridHeight + 'px'}" *ngIf="loaded">
        <kendo-grid #grid [data]="gridView" [rowClass]="rowClass" [navigable]="true"
          [pageable]="total > gridState.take ? { buttonCount: 5, pageSizes: pageSizes} : false"
          [pageSize]="gridState.take" [skip]="gridState.skip" [loading]="loading" [sort]="gridState.sort"
          [filter]="gridState.filter" [sortable]="true" [filterable]="false" [columnMenu]="false" [resizable]="true"
          [reorderable]="false" (dataStateChange)="dataStateChange($event)"
          [selectable]="{ mode: enrollMember && allowMultipleDashboardEnrollment ? 'multiple' : 'single'}"
          [kendoGridSelectBy]="'id'" [selectedKeys]="selectedRecordKeys"
          (selectedKeysChange)="onSelectedKeysChange($event)">
          <kendo-grid-messages noRecords="{{ 'NO-MEMBERS' | translate:patientLabel }}">
          </kendo-grid-messages>
          <ng-template kendoGridToolbarTemplate [position]="'top'" *ngIf="enrollMember">
            <button class="float-right" kendoButton [primary]="true" type="button"
              [disabled]="selectedRecordKeys.length === 0" (click)="enrollPatients()">
              {{'ENROLL-CLIENT' | translate:patientLabel }}<span *ngIf="getSelectedCount() > 0"
                class="ml-1">({{getSelectedCount()}})</span>
            </button>
          </ng-template>
          <kendo-grid-checkbox-column *ngIf="enrollMember" [columnMenu]="false" [width]="8" class="text-center"
            headerClass="text-center" [reorderable]="false">
            <ng-template kendoGridCellTemplate let-idx="rowIndex" let-dataItem>
              <input [kendoGridSelectionCheckbox]="idx" type="checkbox" kendoCheckBox
                attr.aria-label="{{'SELECT-MEMBER' | translate:patientName}}" />
            </ng-template>
          </kendo-grid-checkbox-column>
          <kendo-grid-column field="fullName" title="{{ 'NAME' | translate }}" [width]="15">
            <ng-template kendoGridCellTemplate let-dataItem>
              <a *ngIf="!addHouseholdMember && !enrollMember && dataItem.consentAllowed && !dataItem.patientRestricted"
                title=" {{ 'SELECT-MEMBER' | translate:patientLabel }}" class="pointer emphasizedLabel"
                (click)="navigateToPatient(dataItem.id)" tabindex="0" (keydown.enter)="navigateToPatient(dataItem.id)"
                (keydown.space)="navigateToPatient(dataItem.id)">
                {{ dataItem.fullName }}
              </a>
              <span
                *ngIf="addHouseholdMember || enrollMember || !dataItem.consentAllowed || dataItem.patientRestricted">{{
                dataItem.fullName }}</span>
            </ng-template>
          </kendo-grid-column>
          <kendo-grid-column field="preferredName" title="{{ 'PREFERRED-NAME' | translate }}" [width]="10">
            <ng-template kendoGridCellTemplate let-dataItem>
              <a *ngIf="!addHouseholdMember && !enrollMember && dataItem.consentAllowed && !dataItem.patientRestricted"
                title=" {{ 'SELECT-MEMBER' | translate:patientLabel }}" (click)="navigateToPatient(dataItem.id)"
                tabindex="0" (keydown.enter)="navigateToPatient(dataItem.id)"
                (keydown.space)="navigateToPatient(dataItem.id)" class="emphasizedLabel pointer">
                {{ dataItem.preferredName }}
              </a>
              <span
                *ngIf="addHouseholdMember || enrollMember || !dataItem.consentAllowed || dataItem.patientRestricted">{{
                dataItem.preferredName }}</span>
            </ng-template>
          </kendo-grid-column>
          <kendo-grid-column field="dateOfBirth" title="{{ 'DATE-OF-BIRTH' | translate }}" [width]="10">
            <ng-template kendoGridCellTemplate let-dataItem>
              <span>{{intl.formatDate(intl.parseDate(dataItem.dateOfBirth), "d")}}</span>
            </ng-template>
          </kendo-grid-column>
          <kendo-grid-column field="gender" title="{{ 'GENDER' | translate }}" [width]="10">
          </kendo-grid-column>
          <kendo-grid-column field="streetLine" title="{{ 'ADDRESS' | translate }}" [width]="20" [sortable]="false">
            <ng-template kendoGridCellTemplate let-dataItem>
              <span>{{dataItem.streetLine}}</span>
              <span *ngIf="dataItem.streetLineAdditional"><br />{{dataItem.streetLineAdditional}}</span>
              <br />
              <span *ngIf="dataItem.city">{{dataItem.city}}</span>
              <span *ngIf="dataItem.county">{{dataItem.city ? ', ' + dataItem.county : dataItem.county}}</span>
              <span *ngIf="dataItem.stateCode">{{dataItem.city || dataItem.county ? ', ' +
                dataItem.stateCode:dataItem.stateCode}}</span>
              <span *ngIf="dataItem.postalCode">{{dataItem.city || dataItem.county || dataItem.stateCode ?
                ', ' + dataItem.postalCode : dataItem.postalCode}}</span>
            </ng-template>
          </kendo-grid-column>
          <kendo-grid-column field="email" title="{{ 'EMAIL' | translate }}" [width]="15">
          </kendo-grid-column>
          <kendo-grid-column field="homePhoneNumber" title="{{ 'HOME' | translate }}" [width]="12">
            <ng-template kendoGridCellTemplate let-dataItem>
              <span>{{dataItem.homePhoneNumber | phone}}</span>
            </ng-template>
          </kendo-grid-column>
          <kendo-grid-column field="cellPhoneNumber" title="{{ 'CELL' | translate }}" [width]="12">
            <ng-template kendoGridCellTemplate let-dataItem>
              <span>{{dataItem.cellPhoneNumber | phone}}</span>
            </ng-template>
          </kendo-grid-column>
          <kendo-grid-column field="workPhoneNumber" title="{{ 'WORK-PHONE' | translate }}" [width]="12">
            <ng-template kendoGridCellTemplate let-dataItem>
              <span>{{dataItem.workPhoneNumber | phone}}</span>
            </ng-template>
          </kendo-grid-column>
          <kendo-grid-column field="memberFlagsText" title="{{ 'PATIENT-FLAGS' | translate:patientLabel }}"
            [width]="15">
          </kendo-grid-column>
          <kendo-grid-column *ngIf="externalSearch" field="source.displayName" title="{{ 'SOURCE' | translate }}"
            [width]="10" [sortable]="false">
          </kendo-grid-column>
          <!--Community Invite-->
          <kendo-grid-column field="inviteStatus" title="{{ 'COMMUNITY-INVITE' | translate }}" [width]="5"
            *ngIf="communityEnabled && communityPortalEnabled && !addHouseholdMember && !enrollMember"
            class="text-center" [filterable]="false" [sortable]="false">
            <ng-template kendoGridCellTemplate let-dataItem>
              <div
                *ngIf="!dataItem.patientRestricted && (!externalSearch || dataItem.source && dataItem.source.code === 'CHANNELS')">
                <a *ngIf="dataItem.inviteStatus === null" title="{{'COMMUNITY-INVITE-SEND' | translate}}"
                  (click)="openMethodDialog(dataItem,'INVITE')" tabindex="0"
                  (keydown.enter)="openMethodDialog(dataItem,'INVITE')"
                  (keydown.space)="openMethodDialog(dataItem,'INVITE')">
                  <i class="fas fa-envelope fa-send-document-action fa-lg"></i>
                </a>
                <a *ngIf="dataItem.inviteStatus === 'REGISTERED'"
                  title="{{'COMMUNITY-INVITE-REGISTERED-ON' | translate}}{{dataItem.inviteSentOrRegisteredDate | date: 'MMM d, y, h:mm a'}} {{getInviteFromOrganizationName(dataItem)}}">
                  <i class="fas fa-user-check icon-success fa-lg pl-2"></i>
                </a>
                <a *ngIf="dataItem.inviteStatus === 'SENT'"
                  title="{{'COMMUNITY-INVITE-SENT-ON' | translate}}{{dataItem.inviteSentOrRegisteredDate | date: 'MMM d, y, h:mm a'}} {{getInviteFromOrganizationName(dataItem)}}">
                  <i class="fas fa-paper-plane icon-warn fa-lg"></i>
                </a>
                <a *ngIf="dataItem.inviteStatus === 'EXPIRED'"
                  title="{{'COMMUNITY-INVITE-EXPIRED' | translate}}{{dataItem.inviteSentOrRegisteredDate | date: 'MMM d, y, h:mm a'}} {{getInviteFromOrganizationName(dataItem)}}">
                  <i class="fas fa-ban icon-danger fa-lg"></i>
                </a>
                <a *ngIf="dataItem.inviteStatus === 'SENT' || dataItem.inviteStatus === 'EXPIRED'"
                  title="{{'COMMUNITY-INVITE-RESEND' | translate}}" class="ml-2 pointer"
                  (click)="openMethodDialog(dataItem,'INVITE')" tabindex="0"
                  (keydown.enter)="openMethodDialog(dataItem,'INVITE')"
                  (keydown.space)="openMethodDialog(dataItem,'INVITE')">
                  <i class="fas fa-share icon-info fa-lg"></i>
                </a>
              </div>
            </ng-template>
          </kendo-grid-column>
          <!--Community Consent-->
          <kendo-grid-column field="consent" title="{{ 'CONSENT' | translate }}" [width]="5"
            *ngIf="communityEnabled && communityPortalEnabled && !addHouseholdMember && !enrollMember"
            class="text-center" [filterable]="false" [sortable]="false">
            <ng-template kendoGridCellTemplate let-dataItem>
              <div *ngIf="!externalSearch || dataItem.source && dataItem.source.code === 'CHANNELS'">
                <a *ngIf="dataItem.consent === null  && dataItem.consentRequired" class="pointer"
                  title="{{'REQUEST-CONSENT' | translate}}" (click)="openMethodDialog(dataItem,'CONSENT')" tabindex="0"
                  (keydown.enter)="openMethodDialog(dataItem,'CONSENT')" tabindex="0"
                  (keydown.space)="openMethodDialog(dataItem,'CONSENT')">
                  <i class="far fa-user icon-info fa-lg" role="img"
                    attr.aria-label="{{'REQUEST-CONSENT' | translate}}"></i>
                </a>
                <i *ngIf="!dataItem.consentRequired && dataItem.consent === null"
                  class="far fa-unlock icon-success fa-lg" title="{{'NOT-CONSENTED' | translate}}"></i>
                <a *ngIf="dataItem.consent === 'REJECTED'"
                  title="{{'CONSENT-REJECTED-ON' | translate}}{{dataItem.consentLastUpdate | date: 'MMM d, y, h:mm a'}}">
                  <i class="fas fa-user-lock icon-danger fa-lg" role="img"
                    attr.aria-label="{{'CONSENT-REJECTED-ON' | translate}}{{dataItem.consentLastUpdate | date: 'MMM d, y, h:mm a'}}"></i>
                </a>
                <a *ngIf="dataItem.consent === 'REVOKED'"
                  title="{{'CONSENT-REVOKED-ON' | translate}}{{dataItem.consentLastUpdate | date: 'MMM d, y, h:mm a'}}">
                  <i class="fas fa-user-lock icon-danger fa-lg" role="img"
                    attr.aria-label="{{'CONSENT-REVOKED-ON' | translate}}{{dataItem.consentLastUpdate | date: 'MMM d, y, h:mm a'}}"></i>
                </a>
                <a *ngIf="dataItem.consent === 'REQUESTED'"
                  title="{{'CONSENT-REQUESTED-ON' | translate}}{{dataItem.consentLastUpdate | date: 'MMM d, y, h:mm a'}}">
                  <i class="fas fa-user-cog icon-warn fa-lg" role="img"
                    attr.aria-label="{{'CONSENT-REQUESTED-ON' | translate}}{{dataItem.consentLastUpdate | date: 'MMM d, y, h:mm a'}}"></i>
                </a>
                <a *ngIf="dataItem.consent === 'REQUESTED' || dataItem.consent === 'REJECTED' || dataItem.consent === 'REVOKED'"
                  title="{{'RESEND-REQUEST' | translate}}" class="ml-2 pointer" tabindex="0"
                  (click)="openMethodDialog(dataItem,'CONSENT')" tabindex="0"
                  (keydown.enter)="openMethodDialog(dataItem,'CONSENT')"
                  (keydown.space)="openMethodDialog(dataItem,'CONSENT')">
                  <i class="fas fa-share icon-info fa-lg" role="img"
                    attr.aria-label="{{'RESEND-REQUEST' | translate}}"></i>
                </a>
                <a *ngIf="dataItem.consent === 'ACCEPTED'"
                  title="{{'CONSENT-ACCEPTED-ON' | translate}}{{dataItem.consentLastUpdate | date: 'MMM d, y, h:mm a'}}">
                  <i class="fas fa-user-unlock icon-success fa-lg" role="img"
                    attr.aria-label="{{'CONSENT-ACCEPTED-ON' | translate}}{{dataItem.consentLastUpdate | date: 'MMM d, y, h:mm a'}}"></i>
                </a>
              </div>
            </ng-template>
          </kendo-grid-column>
          <kendo-grid-command-column *ngIf="externalSearch && !addHouseholdMember && !enrollMember" [width]="5"
            title="{{ 'ACTIONS' | translate }}" class="text-center">
            <ng-template kendoGridCellTemplate let-dataItem>
              <i class="fas fa-plus fa-lg pointer" title="{{ 'ADD' | translate }}" (click)="importMember(dataItem)"
                tabindex="0" (keydown.enter)="importMember(dataItem)" (keydown.space)="importMember(dataItem)"
                style="color: #6695bf" *ngIf="dataItem.source && dataItem.source.code !== 'CHANNELS'">
              </i>
            </ng-template>
          </kendo-grid-command-column>
          <!--Add Household Member-->
          <kendo-grid-command-column *ngIf="addHouseholdMember" [width]="5" title="{{ 'LINK' | translate }}"
            class="text-center">
            <ng-template kendoGridCellTemplate let-dataItem>
              <i class="fas fa-user-plus fa-lg pointer" title="{{ 'ADD-HOUSEHOLD-MEMBER' | translate }}"
                (click)="addNewHouseholdMember(dataItem)" style="color: #6695bf" *ngIf="dataItem.id !== member.id && !isLinkedMember(dataItem.id) && 
                dataItem.consentAllowed && !dataItem.patientRestricted" tabindex="0"
                (keydown.enter)="addNewHouseholdMember(dataItem)" (keydown.space)="addNewHouseholdMember(dataItem)">
              </i>
            </ng-template>
          </kendo-grid-command-column>
        </kendo-grid>
      </div>
    </div>
  </form>
</ng-template>